import Reflux from "reflux";

const LottieActions = Reflux.createActions([
  "togglePlayPause",
  "setPlayingState",
  "setLoadError",
  "cleanup",
]);

export default LottieActions;
